// Shared palette for both TagsPanel (Admin.jsx) and TagManager (ApplicationsPanel.jsx).
export const TAG_PALETTE = [
    { name: "gold", hex: "#c5a059" },
    { name: "wine", hex: "#8b3a3f" },
    { name: "sage", hex: "#7a8e6b" },
    { name: "sky", hex: "#6b8ba4" },
    { name: "clay", hex: "#c9846a" },
    { name: "plum", hex: "#8b5a8b" },
];
